import Navbar from "./components/Navbar";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Pitches from "./pages/Pitches";
import Contact from "./pages/Contact";
import Login from "./pages/Login";

import Pitch from "./pages/Pitch";
import Footer1 from "./components/Footer1";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import AddPitch from "./pages/AddPitch";
import AddPlayer from "./pages/AddPlayer";
import { ToastContainer } from "react-toastify";
import { useContext } from "react";
import { PitchContext } from "./context/PitchContex";
import { IoMdFootball } from "react-icons/io";
import AdminPitchBookings from "./pages/AdminPitchBookings";
import Verify from "./pages/Verify";
import Payment from "./pages/Payment";

import MyToast from "./components/MyToast";
import ForgotPassword from "./pages/ForgotPassword";
import RenewPassword from "./pages/RenewPassword";
import AllPlayers from "./pages/AllPlayers";
import Player from "./pages/Player";
import WhatsAppButton from "./components/WhatsAppButton";
import DeliveryAndReturns from "./pages/DeliveryAndReturns";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DistantSalesAgreement from "./pages/DistantSalesAgreement";
import AllTeams from "./pages/AllTeams";
import Team from "./pages/Team";
import AddTeam from "./pages/AddTeam";
import VerifyPhone from "./pages/VerifyPhone";
import PaymentResult from "./pages/PaymentResult";
import PaymentPage from "./components/PaymentPage";
import Payments from "./pages/Payments";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import { useLocation } from "react-router-dom";

function App() {
  const { pending, showAlert, setShowAlert, alertMessage, isErr } =
    useContext(PitchContext);
  const location = useLocation();
  const hideLayout = location.pathname.startsWith("/odeme/");
  return (
    <div className="min-h-screen flex flex-col">
      {!hideLayout && <Navbar />}
      <main className=" sm:px-[5vw] md:px-[7vw] lg:px-[5vw]">
        {pending ? (
          <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center  bg-opacity-30 backdrop-blur-md z-50">
            <IoMdFootball className="text-5xl text-[#6ca87e] animate-bounce-slow" />
          </div>
        ) : null}
        <MyToast
          triggerCondition={showAlert}
          setTriggerCondition={setShowAlert}
          message={alertMessage}
          isErr={isErr}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/sahalar" element={<Pitches />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/giris-yap" element={<Login />} />
          <Route path="/kayit-ol" element={<Register />} />
          <Route path="/sahalar/:slug" element={<Pitch />} />
          <Route path="/profil" element={<Profile />} />
          <Route path="/profil-duzenle" element={<EditProfile />} />
          <Route path="/oyuncu-ekle" element={<AddPlayer />} />
          <Route path="/saha-ekle" element={<AddPitch />} />
          <Route path="/takim-arkadasi-bul" element={<AllPlayers />} />
          <Route path="/rakip-bul" element={<AllTeams />} />
          <Route path="/rakip-bul/:slug" element={<Team />} />
          <Route path="/takim-ekle" element={<AddTeam />} />
          <Route path="/kiralamalar/:slug" element={<AdminPitchBookings />} />
          <Route path="/verify/:token" element={<Verify />} />
          <Route path="/verify-phone/:token" element={<VerifyPhone />} />
          <Route path="/payment/:slug" element={<Payment />} />
          <Route path="/oyuncu/:id" element={<Player />} />
          <Route path="/teslimat-iade" element={<DeliveryAndReturns />} />
          <Route path="/gizlilik-politikasi" element={<PrivacyPolicy />} />
          <Route path="/mesafeli-satis" element={<DistantSalesAgreement />} />
          <Route path="/password/:token" element={<RenewPassword />} />
          <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
          <Route path="/payment-success/:slug" element={<PaymentSuccess />} />
          <Route path="/payment-fail/:slug" element={<PaymentFailed />} />
          <Route path="/odeme/:slug" element={<PaymentPage />} />
          <Route path="/odemeler" element={<Payments />} />
        </Routes>
        {!hideLayout && <Footer1 />}
        <ToastContainer />
        {!hideLayout && <WhatsAppButton />}
      </main>
    </div>
  );
}

export default App;
